import React, { useCallback, useEffect, useRef, useState } from "react";
import BaseHome from "../Home/BaseHome";
import Userchar from "../../assets/images/userchar.png";
import LevelIcon from "../../assets/images/levelicon1.png";
import { getUserStateDetail, getUserDetails } from "../../api/profile.api";
import { getTopProfiles, getFollowers } from "../../api/worldOfEsports.api";
import { url } from "../../config/url";
import User from "../../assets/images/user-icon.svg";
import LevelsPopup from "../Popup/LevelsPopup";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import ListLoader from "../Common/ListLoader";

const UserProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("stats");
  const [userProfile, setUserProfile] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLevelsPopup, setIsLevelsPopup] = useState(false);
  const [tournamentData, setTournamentData] = useState([]);
  const [rank, setRank] = useState([]);
  const [totalPlayed, setTotalPlayed] = useState([]);
  const [won, setWon] = useState([]);
  const [style, setStyle] = useState({});
  const [style1, setStyle1] = useState({});

  // Get the current user ID from local storage
  const currentUserId = JSON.parse(localStorage.getItem("profile"))?._id;

  useEffect(() => {
    fetchUserProfile();
    fetchStats();
  }, []);

  const handleFollowToggle = async (profileId, isFollow, currentFollowers) => {
    const action = isFollow ? "unfollow" : "follow";
    const followingUser = profileId;

    try {
      const res = await getFollowers({ action, followingUser });

      if (res?.success) {
        // Update the follower count and follow state
        fetchUserProfile(); // Refresh the user profile after toggling
      }
    } catch (error) {
      console.error("Failed to toggle follow state", error);
    }
  };

  const fetchStats = async () => {
    setLoading(true);
    try {
      const res = await getUserStateDetail(id);
      setLoading(false);
      if (res?.success && res?.data) {
        setTournamentData(res.data);
        setRank(res?.totalRank);
        setTotalPlayed(res?.totalPlayed);
        setWon(res?.totalWon);
      }
    } catch (error) {
      console.error("Error fetching stats:", error);
      setLoading(false);
    }
  };

  const fetchUserProfile = async () => {
    try {
      const res = await getUserDetails(id);
      if (res?.success && res?.data) {
        setUserProfile(res?.data);
      } else {
        setUserProfile("");
      }
    } catch (error) {
      setUserProfile("");
    }
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const currentLevelPoints =
    (userProfile?.level?.endPoint || 0) -
    ((userProfile?.level?.startPoint || 0) - 1);
  const userPointsAsPerLevel =
    (userProfile?.totalPoint || 0) -
    ((userProfile?.level?.startPoint || 0) - 1);
  const percentage = (userPointsAsPerLevel * 100) / currentLevelPoints;

  return (
    <BaseHome
      title="profile"
      setStyle={setStyle}
      setStyle1={setStyle1}
      onBackClick={() => navigate(-1)}
    >
      <div className="userprofile-esports-container">
        <div className="userprofile-esports-header">
          <div className="userprofile-esports-userinfo-img-wrap">
            <div className="userprofile-esports-userinfo-wrap">
              <div className="userprofile-esports-userinfo">
                <div className="userprofile-name-svg-flex">
                  <div className="userprofile-esports-username">
                    {userProfile?.gamerjiName}
                  </div>
                </div>
                <div className="userprofile-esports-followers">
                  <div className="userprofile-flex">
                    <div className="user-profile-followers-total">
                      {userProfile?.followers || 0}
                    </div>
                    <div className="user-profile-followers-title">
                    {/* {userProfile?.followers === 1 ? 'follower' : 'followers'} */}
                    {userProfile?.followers <= 1 ? 'follower' : 'followers'}
                    </div>
                  </div>
                  <div className="userprofile-flex profile-child">
                    <div className="user-profile-followers-total">
                      {userProfile?.followings || 0}
                    </div>
                    <div className="user-profile-followers-title">
                      following
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="userprofile-esports-level">
              <div className="userprofile-esports-level-icon">
                {userProfile?.level?.featuredImage?.default ? (
                  <img
                    src={
                      url?.IMAGE_URL +
                      userProfile?.level?.featuredImage?.default
                    }
                    alt={userProfile?.level?.name}
                  />
                ) : (
                  <img src={User} alt={userProfile?.level?.name} />
                )}
              </div>
              <div className="userprofile-esports-level-info">
                <div className="user-profile-levelname">
                  {userProfile?.level?.name}
                </div>
                <div className="user-profile-levels-flex user-profile-levels-flex-1">
                  <div className="user-profile-levels">
                    Level {userProfile?.level?.num || 0}
                  </div>
                  <div className="user-profile-levels">
                    {userProfile?.totalPoint || 0} points
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center mt-1">
                  <div
                    className="progress"
                    style={{ height: "6px", width: "100%" }}
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${percentage}%`,
                        backgroundColor:
                          percentage >= 100 ? "transparent" : "#9F6693",
                      }}
                      aria-valuenow={userProfile?.level?.startPoint || 0}
                      aria-valuemin="0"
                      aria-valuemax={userProfile?.level?.endPoint || 0}
                    ></div>
                  </div>
                </div>
                <p className="progressbar-text user-profile-progressbar mt-1">
                  <div>{userProfile?.level?.startPoint || 0} pts</div>
                  <div>{userProfile?.level?.endPoint || 0} pts</div>
                </p>
              </div>
            </div>
            {/* Conditionally render the follow button */}
            {userProfile?._id !== currentUserId && (
              <div
                className="all-levels-user-profile"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  handleFollowToggle(
                    userProfile._id,
                    userProfile?.isFollow,
                    userProfile.followers
                  )
                }
              >
                {userProfile?.isFollow ? "following" : "follow"}
              </div>
            )}
          </div>
          <div className="userprofile-esports-avatar">
            <img
              src={url?.IMAGE_URL + userProfile?.avatar?.img?.default}
              alt="Avatar"
              style={{objectFit:"contain"}}
            />
          </div>
        </div>

        <div className="userprofile-esports-stats userprofile-esports-stats-1"></div>
        <div className="userprofile-esports-ranking">
          <div className="user-profiles-dflex">
            <div className="userprofile-ranks-details">#{rank}</div>
            <div className="userprofile-ranks-details-ranks">rank</div>
          </div>
          <div className="user-profiles-dflex">
            <div className="userprofile-ranks-details">#{totalPlayed}</div>
            <div className="userprofile-ranks-details-ranks">played</div>
          </div>
          <div className="user-profiles-dflex">
            <div className="userprofile-ranks-details">#{won}</div>
            <div className="userprofile-ranks-details-ranks">won</div>
          </div>
        </div>

        <div className="userprofiles-tab-container mt-4">
          <button className="userprofiles-tab-btn active">stats</button>
        </div>

        <div className="userprofiles-tab-content mt-4">
          {activeTab === "stats" && (
            <div className="container tournament-card--wrap user-profile-spacing mt-3">
              {tournamentData?.length > 0
                ? tournamentData.map((tournament, index) => (
                    <div className="tournament-card stat-tournament-card" key={index}>
                      <div className="card-body d-flex flex-column justify-content-between">
                        <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex justify-content-between align-items-center">
  <div className="card-title card-title-name-ellipsis card-title-name-ellipsis-1">
    {tournament.gameName?.toLowerCase()} - {tournament.userInGameName?.toLowerCase()}
  </div>
</div>
                        </div>
                        <hr style={{ margin: "8px 0" }} />
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="tournament-card-detail stat-tournament-card-detail">
                              <div className="row">
                                <div className="col-4 tournament-card-box">
                                  <div className="detail-item">
                                    <div className="tournament-detail-label">
                                      #{tournament.rank}
                                    </div>
                                    <div className="tournament-detail-value">
                                      rank
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4 tournament-card-box">
                                  <div className="detail-item">
                                    <div className="tournament-detail-label">
                                      #{tournament.played}
                                    </div>
                                    <div className="tournament-detail-value">
                                      played
                                    </div>
                                  </div>
                                </div>
                                <div className="col-4 tournament-card-box">
                                  <div className="detail-item">
                                    <div className="tournament-detail-label">
                                      #{tournament.won}
                                    </div>
                                    <div className="tournament-detail-value">
                                      won
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="col-3 tournament-card-box">
                                  <div className="detail-item">
                                    <div className="tournament-detail-label">
                                      {tournament.top}
                                    </div>
                                    <div className="tournament-detail-value">
                                      top 10
                                    </div>
                                  </div>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : !loading && (
                    <div className="text-center" style={{ width: "100%" }}>
                      <span className="text-center">no data found</span>
                    </div>
                  )}
              {loading && (
                <div className="w-100 d-flex justify-content-center">
                  <ListLoader />
                </div>
              )}
            </div>
          )}
          {activeTab === "collegiate" && <div>no data found</div>}
        </div>
        {isLevelsPopup && (
          <LevelsPopup
            isOpen={isLevelsPopup}
            title="levels"
            onClose={() => setIsLevelsPopup(false)}
          />
        )}
      </div>
    </BaseHome>
  );
};

export default UserProfile;
